export default {
    REDUCER_KEY: "TEMPLATE_DOCUMENT",
    ENTITY_NAME: "templateDocument",
    RESOURCE: "templateDocument",
};
